export function percentageToShare(percentage: string): number {
    const v = Number(percentage);
    if (Number.isNaN(v)) return 0;
    const clamped = Math.max(0, Math.min(100, v));
    return clamped / 100;
}
